/**
 * @license @tabler/icons-react v3.17.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconTrack = createReactComponent("outline", "track", "IconTrack", [["path", { "d": "M4 15l11 -11m5 5l-11 11m-4 -8l7 7m-3.5 -10.5l7 7m-3.5 -10.5l7 7", "key": "svg-0" }]]);

export { IconTrack as default };
//# sourceMappingURL=IconTrack.mjs.map
